<template>
  <div class="admin__poem-new">

    <p class="admin__poem-new-title" v-if="mode === 'new'">
      Új vers hozzáadása
    </p>
    <p v-else class="admin__poem-new-title">
      Vers szerkesztése
    </p>

    <!--    TODO: back to list-->
    <svg class="admin__poem-new-arrow" viewBox="7496 5161 16.453 13.358" @click="changeRoute('/admin/versek')">
      <path id="Path_3" d="M 7496 5161 L 7504.3740234375 5174.3583984375 L 7512.453125 5161">
      </path>
    </svg>
    '
    <b-form-input class="admin__poem-form-name" v-model="form.title" type="text" placeholder="Vers címe"></b-form-input>
    <b-form-textarea
        class="admin__poem-form-text"
        v-model="form.text"
        placeholder="Vers szövege"
        rows="3"
        max-rows="6"
    ></b-form-textarea>
    <!--    TODO: add clear location-->
    <b-form-input class="admin__poem-form-location" v-model="form.otherInformations" type="text"
                  placeholder="Helyszín"></b-form-input>

    <!--    TODO: button style and logic-->
    <div class="admin__poem-form-buttons">

      <div class="d-flex" v-for="(category, i) in form.categories" v-bind:key="i">
        <b-button pill
                  :style="[category.active ? {
                          'background-color': `${category.color} !important`,
                          'border': `1px solid ${category.color} !important`
                      } : {
                          'background-color': `transparent !important`,
                          'border': `1px solid white !important`
                      }]"
                  @click="selectCategory(category.name)">
          {{ category.name }}
        </b-button>
        <div v-for="(subCategory, j) in category.subCategories" v-bind:key="j">
          <b-button pill
                    class="admin__poem-form-buttons-sub"
                    :class="{visible: category.active}"
                    :disabled="!category.active"
                    :style="[subCategory.active ? {
                              'background-color': `${category.color} !important`,
                              'border': `1px solid ${category.color} !important`
                          } : {
                              'background-color': `transparent !important`,
                              'border': `1px solid white !important`
                          }]"
                    @click="selectCategory(subCategory.name)">
            {{ subCategory.name }}
          </b-button>
        </div>
      </div>
      <!--      <div class="d-flex">-->
      <!--        -->
      <!--      </div>-->
      <!--      <div class="d-flex">-->
      <!--        <b-button pill>Lélek</b-button>-->
      <!--        <b-button pill>Mámor</b-button>-->
      <!--        <b-button pill>Bánat</b-button>-->
      <!--      </div>-->
      <!--      <div class="d-flex">-->
      <!--        <b-button pill>Test</b-button>-->
      <!--        <b-button pill>Itthon</b-button>-->
      <!--        <b-button pill>Külföld</b-button>-->
      <!--      </div>-->

    </div>
    <b-form-datepicker v-model="form.date" class="mb-2 admin__poem-form-date" label-no-date-selected="Dátum"
                       start-weekday="1"></b-form-datepicker>
    <!--    <div id="Group_31">-->
    <!--      <svg class="Path_30_bm" viewBox="-15771.857 -6876.082 369.695 2">-->
    <!--        <path id="Path_30_bm" d="M -15771.857421875 -6876.08203125 L -15402.162109375 -6876.08203125">-->
    <!--        </path>-->
    <!--      </svg>-->
    <!--      <svg class="Path_33_bn" viewBox="187.719 22.889 14.47 14.469">-->
    <!--        <path id="Path_33_bn" d="M 188.8324584960938 37.35843276977539 L 187.718994140625 36.24566650390625 L 193.8410034179688 30.12371635437012 L 187.718994140625 24.00176620483398 L 188.8324584960938 22.88899993896484 L 194.9537658691406 29.01025390625 L 201.0757751464844 22.88899993896484 L 202.1892395019531 24.00176620483398 L 196.0672302246094 30.12371635437012 L 202.1892395019531 36.24566650390625 L 201.0757751464844 37.35843276977539 L 194.9537658691406 31.23648071289062 L 188.8324584960938 37.35843276977539 Z">-->
    <!--        </path>-->
    <!--      </svg>-->
    <!--    </div>-->

    <div id="preview" v-if="mode === 'new'">
      <img v-if="url" :src="url"/>
      <!--          <svg viewBox="0 0 14.47 14.47" v-if="url" @click="removeFile">-->
      <!--              <polygon class="cls-1" points="14.47 1.11 13.36 0 7.23 6.12 1.11 0 0 1.11 6.12 7.24 0 13.36 1.11 14.47 7.24 8.35 13.36 14.47 14.47 13.36 8.35 7.24 14.47 1.11"/>-->
      <!--          </svg>-->
    </div>

    <div v-else id="preview">
      <div v-if="form.image">
        <img v-if="form.image" :src="form.image"/>
        <!--              <svg viewBox="0 0 14.47 14.47" v-if="form.image" @click="removeFile">-->
        <!--                  <polygon class="cls-1" points="14.47 1.11 13.36 0 7.23 6.12 1.11 0 0 1.11 6.12 7.24 0 13.36 1.11 14.47 7.24 8.35 13.36 14.47 14.47 13.36 8.35 7.24 14.47 1.11"/>-->
        <!--              </svg>-->

      </div>
      <div v-else-if="url">
        <img v-if="url" :src="url"/>
        <!--              <svg viewBox="0 0 14.47 14.47" v-if="url" @click="removeFile">-->
        <!--                  <polygon class="cls-1" points="14.47 1.11 13.36 0 7.23 6.12 1.11 0 0 1.11 6.12 7.24 0 13.36 1.11 14.47 7.24 8.35 13.36 14.47 14.47 13.36 8.35 7.24 14.47 1.11"/>-->
        <!--              </svg>-->
      </div>


    </div>

    <div class="image-upload" :class="{rotate: url !== null || form.image !== null}" @click="removeFile">
      <label for="file-input">
        <svg class="admin__poem-form-img" viewBox="0 0 48 48">
          <polygon class="cls-2"
                   points="24.59 22.95 24.59 7.8 22.59 7.8 22.59 22.95 7.45 22.95 7.45 24.95 22.59 24.95 22.59 40.09 24.59 40.09 24.59 24.95 39.74 24.95 39.74 22.95 24.59 22.95"/>
          <path class="cls-2"
                d="M41,7A24,24,0,0,0,7.24,6.84L7,7l-.17.19a24,24,0,0,0,0,33.56L7,41a1.22,1.22,0,0,0,.17.15A24,24,0,0,0,41,7ZM39.56,39.56a22,22,0,1,1,0-31.12A22,22,0,0,1,39.56,39.56Z"/>
          <path class="cls-2" d="M7.2,41.12A24,24,0,0,0,41,41a24,24,0,0,1-33.77.15Z"/>
        </svg>
      </label>
      <input id="file-input" type="file" @change="onFileChange"/>
    </div>

    <p class="admin__poem-new-create" @click="handleClick" :class="{create_disabled: !this.fieldsFilled}">
      <span v-if="mode === 'new' && !isCreated">Hozzáad</span>
      <span v-else-if="mode === 'new' && isCreated" class="admin__poem-new-created">Hozzáadva!</span>
      <span v-if="mode === 'edit' && !isCreated">Szerkesztés</span>
      <span v-else-if="mode === 'edit' && isCreated" class="admin__poem-new-created">Szerkesztve!</span>
    </p>


    <!--    TODO: add preview button-->
    <!--    <div id="Group_39">-->
    <!--      <svg class="Path_41" viewBox="14.966 20.848 36.97 25.207">-->
    <!--        <path id="Path_41" d="M 33.45100021362305 40.59299850463867 C 35.43999862670898 40.59299850463867 37.12699890136719 39.90000152587891 38.51399993896484 38.51399993896484 C 39.90000152587891 37.12699890136719 40.59299850463867 35.43999862670898 40.59299850463867 33.45100021362305 C 40.59299850463867 31.46299934387207 39.90000152587891 29.77499961853027 38.51399993896484 28.38899993896484 C 37.12699890136719 27.00300025939941 35.43999862670898 26.30900001525879 33.45100021362305 26.30900001525879 C 31.46299934387207 26.30900001525879 29.77499961853027 27.00300025939941 28.38899993896484 28.38899993896484 C 27.00300025939941 29.77499961853027 26.30900001525879 31.46299934387207 26.30900001525879 33.45100021362305 C 26.30900001525879 35.43999862670898 27.00300025939941 37.12699890136719 28.38899993896484 38.51399993896484 C 29.77499961853027 39.90000152587891 31.46299934387207 40.59299850463867 33.45100021362305 40.59299850463867 Z M 33.45100021362305 38.15700149536133 C 32.1349983215332 38.15700149536133 31.02199935913086 37.70100021362305 30.11100006103516 36.79100036621094 C 29.20100021362305 35.88100051879883 28.74600028991699 34.76800155639648 28.74600028991699 33.45100021362305 C 28.74600028991699 32.1349983215332 29.20100021362305 31.02199935913086 30.11100006103516 30.11100006103516 C 31.02199935913086 29.20100021362305 32.1349983215332 28.74600028991699 33.45100021362305 28.74600028991699 C 34.76800155639648 28.74600028991699 35.88100051879883 29.20100021362305 36.79100036621094 30.11100006103516 C 37.70100021362305 31.02199935913086 38.15700149536133 32.1349983215332 38.15700149536133 33.45100021362305 C 38.15700149536133 34.76800155639648 37.70100021362305 35.88100051879883 36.79100036621094 36.79100036621094 C 35.88100051879883 37.70100021362305 34.76800155639648 38.15700149536133 33.45100021362305 38.15700149536133 Z M 33.45100021362305 46.05500030517578 C 29.36199951171875 46.05500030517578 25.66500091552734 44.89199829101562 22.36000061035156 42.56800079345703 C 19.05500030517578 40.24300003051758 16.59099960327148 37.20399856567383 14.96599960327148 33.45100021362305 C 16.59099960327148 29.69799995422363 19.05500030517578 26.65900039672852 22.36000061035156 24.33499908447266 C 25.66500091552734 22.01000022888184 29.36199951171875 20.84799957275391 33.45100021362305 20.84799957275391 C 37.54000091552734 20.84799957275391 41.23699951171875 22.01000022888184 44.54199981689453 24.33499908447266 C 47.84700012207031 26.65900039672852 50.3120002746582 29.69799995422363 51.93600082397461 33.45100021362305 C 50.3120002746582 37.20399856567383 47.84700012207031 40.24300003051758 44.54199981689453 42.56800079345703 C 41.23699951171875 44.89199829101562 37.54000091552734 46.05500030517578 33.45100021362305 46.05500030517578 Z M 33.45100021362305 43.53400039672852 C 36.84000015258789 43.53400039672852 39.95600128173828 42.61700057983398 42.79899978637695 40.78200149536133 C 45.64199829101562 38.94800186157227 47.80500030517578 36.50400161743164 49.29000091552734 33.45100021362305 C 47.80500030517578 30.39800071716309 45.64199829101562 27.95499992370605 42.79899978637695 26.1200008392334 C 39.95600128173828 24.2859992980957 36.84000015258789 23.36899948120117 33.45100021362305 23.36899948120117 C 30.0620002746582 23.36899948120117 26.94599914550781 24.2859992980957 24.10400009155273 26.1200008392334 C 21.26099967956543 27.95499992370605 19.08300018310547 30.39800071716309 17.57099914550781 33.45100021362305 C 19.08300018310547 36.50400161743164 21.26099967956543 38.94800186157227 24.10400009155273 40.78200149536133 C 26.94599914550781 42.61700057983398 30.0620002746582 43.53400039672852 33.45100021362305 43.53400039672852 Z">-->
    <!--        </path>-->
    <!--      </svg>-->
    <!--      <div id="Group_38">-->
    <!--        <div id="Group_37">-->
    <!--          <div id="Group_36">-->
    <!--            <svg class="Path_42" viewBox="0 0 66.903 66.903">-->
    <!--              <path id="Path_42" d="M 33.45100021362305 66.90299987792969 C 15.00599956512451 66.90299987792969 0 51.89599990844727 0 33.45100021362305 C 0 15.00599956512451 15.00599956512451 0 33.45100021362305 0 C 51.89599990844727 0 66.90299987792969 15.00599956512451 66.90299987792969 33.45100021362305 C 66.90299987792969 51.89599990844727 51.89599990844727 66.90299987792969 33.45100021362305 66.90299987792969 Z M 33.45100021362305 2 C 16.10899925231934 2 2 16.10899925231934 2 33.45100021362305 C 2 50.79299926757812 16.10899925231934 64.90299987792969 33.45100021362305 64.90299987792969 C 50.79399871826172 64.90299987792969 64.90299987792969 50.79299926757812 64.90299987792969 33.45100021362305 C 64.90299987792969 16.10899925231934 50.79399871826172 2 33.45100021362305 2 Z">-->
    <!--              </path>-->
    <!--            </svg>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "AdminPoemNew",
  data() {
    return {
      actives: [],
      form: {
        title: null,
        text: null,
        date: null,
        otherInformations: null,
        image: null,
        categories: null,
      },
      url: null,
      base64: null,
      isCreated: false,
      mode: 'new',
    }
  },
  computed: {
    // a computed getter
    fieldsFilled() {
      if (this.form.categories) {
        let isAnyCategorySelected = false;
        this.form.categories.forEach(e => {
          if (e.active) isAnyCategorySelected = true;
        })

        return this.form.title && this.form.text && this.form.date && this.form.otherInformations && isAnyCategorySelected;
      }
      return false;
    }
  },
  methods: {
    async getCategories() {
      let result = await this.apiRequest('GET', '/category/all');
      if (result?.data) {
        let categories = [];
        result.data.forEach(e => {
          e.active = false;
          e.subCategories.forEach(j => {
            j.active = false;
          })
          if (e.name === 'Szellem') categories[0] = e;
          if (e.name === 'Lélek') categories[1] = e;
          if (e.name === 'Test') categories[2] = e;
        })
        this.form.categories = categories;
      }
    },
    async handleClick() {
      if (this.mode === 'new') {
        await this.createPoem();
      } else {
        await this.editPoem();
      }
    },
    async createPoem() {
      if (this.base64 !== null) this.form.image = this.base64;
      let result = await this.apiRequest('POST', '/poem/create', this.form);
      if (result.status) {
        this.isCreated = true;
        this.form.title = null;
        this.form.text = null;
        this.form.date = null;
        this.form.otherInformations = null;
        this.form.image = null;
        this.url = null;
        this.base64 = null;

        await this.getCategories();
        await this.loadContent();
        let timer = setTimeout(() => {
          this.isCreated = false;
          clearTimeout(timer);
        }, 3000);

      }
    },
    async editPoem() {
      if (this.base64 !== null) this.form.image = this.base64;
      let result = await this.apiRequest('PUT', `/poem/${this.form._id}`, this.form);
      // this.url = null;
      // this.base64 = null;
      if (result?.status) {
        this.isCreated = true;
        let timer = setTimeout(() => {
          this.isCreated = false;
          clearTimeout(timer);
        }, 3000);

      }
    },
    selectCategory(name) {
      this.form.categories.forEach(e => {
        if (e.name === name) {
          e.active = !e.active;
          if (!e.active) {
            e.subCategories.forEach(sub => {
              sub.active = false;
            })
          }
        } else {
          e.subCategories.forEach(sub => {
            if (sub.name === name) {
              sub.active = !sub.active;
            }
          })
        }

      })
    },
    async loadPoem() {
      let id = this.$route.path.replace("/admin/versek/szerkeszt/", "");
      let result = await this.apiRequest('GET', `/poem/${id}`);
      if (result?.data) {
        this.form = result.data
      }
    },
    // async onFileChange(e) {
    //   const file = e.target.files[0];
    //   console.log('file', file)
    //   this.base64 = await this.getBase64(file);
    //
    //   this.url = URL.createObjectURL(file);
    // },

    async getBase64(file) {
      return new Promise((resolve, reject) => {
        // 500 KB limit = 512,000 byte.
        // Mivel a Base64 string hossza ~33%-kal nagyobb a binárisnál,
        // a bűvös számunk kb. 680,000 karakter.
        const MAX_BYTE_SIZE = 500 * 1024;
        const MAX_BASE64_LENGTH = MAX_BYTE_SIZE * 1.33;

        // Ha eleve WebP és kicsi, csak olvassuk be (felesleges újra skálázni)
        if (file.type === 'image/webp' && file.size <= MAX_BYTE_SIZE) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;

          img.onload = () => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            // FullHD limit a biztonság kedvéért (ezen felül már felesleges webre)
            const MAX_WIDTH = 1920;
            const MAX_HEIGHT = 1080;

            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
              const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
              width *= ratio;
              height *= ratio;
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            // Fehér háttér biztosítása (ha átlátszó PNG-t konvertálunk WebP-be/JPG-be)
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);

            // Iteratív tömörítés WebP formátumban
            let quality = 0.8; // Jó kiindulópont
            let base64 = canvas.toDataURL('image/webp', quality);

            // Ha még mindig túl nagy, csökkentjük a minőséget
            while (base64.length > MAX_BASE64_LENGTH && quality > 0.1) {
              quality -= 0.1;
              base64 = canvas.toDataURL('image/webp', quality);
            }

            // Ha a böngésző véletlenül nem támogatná a WebP-t (nagyon ritka 2026-ban),
            // a toDataURL visszaesik image/png-re. Ekkor érdemes JPEG-re váltani kényszerítve.
            if (!base64.startsWith('data:image/webp')) {
              base64 = canvas.toDataURL('image/jpeg', quality);
            }

            console.log(`Eredeti: ${(file.size / 1024).toFixed(0)} KB -> Új: ${(base64.length * 0.75 / 1024).toFixed(0)} KB`);
            resolve(base64);
          };
          img.onerror = error => reject(error);
        };
        reader.onerror = error => reject(error);
      });
    },



    async onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        try {





          const base64String = await this.getBase64(file);
          this.base64 = await this.convertToWebP(base64String);

          this.url = URL.createObjectURL(file);
        } catch (error) {
          console.error('Error converting image:', error);
        }
      }
    },

    convertToWebP(base64String) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {

          // Calculate new dimensions while maintaining aspect ratio
          let newWidth = img.width;
          let newHeight = img.height;
          if (newWidth > 1920) {

            const aspectRatio = img.height / img.width;
            newWidth = 1920;
            newHeight = Math.round(newWidth * aspectRatio);
          }

          const canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, newWidth, newHeight); // Draw the resized image onto the canvas
          canvas.toBlob(blob => {
            // Set maximum target file size (100KB)
            console.log('blob', blob)
            const maxSizeInBytes = 250 * 1024;

            // Quality adjustment loop
            let quality = 1;
            let done = false;
            let webPString = canvas.toDataURL('image/webp', quality);
            let fileSizeInBytes = Math.round((webPString.length * 3) / 4);
            while (!done && quality > 0 && fileSizeInBytes > maxSizeInBytes) {
              webPString = canvas.toDataURL('image/webp', quality);
              fileSizeInBytes = Math.round((webPString.length * 3) / 4); // Base64 string length estimation
              if (fileSizeInBytes <= maxSizeInBytes || quality <= 0) {

                done = true;
                const base64Data = webPString.split(',')[1]; // Get the Base64 data after the comma
                resolve(`data:image/webp;base64,${base64Data}`);
              } else {

                quality -= 0.01;
              }
            }
          }, 'image/webp');
        };
        img.onerror = error => reject(error);
        img.src = base64String;
      });
    },



    removeFile() {
      this.url = null;
      this.base64 = null;
      this.form.image = null;
    },
    async loadContent() {
      let result = await this.apiRequest('GET', '/content/all');
      if (result?.data) {
        this.form.categories[0].color = result.data[0].colors[0].colorDark;
        this.form.categories[1].color = result.data[0].colors[1].colorDark
        this.form.categories[2].color = result.data[0].colors[2].colorDark
      }
    },

  },
  async mounted() {
    await this.getCategories();
    await this.loadContent();
    if (this.$route.path.includes('/versek/szerkeszt')) {
      this.mode = 'edit';
      await this.loadPoem();
    }
  }
}
</script>

<style scoped>
.admin__poem-form-img {
  cursor: pointer;
}

.rotate {
  transform: rotate(45deg);
}

.admin__poem-new-created {
  color: #823033 !important;
}

.admin__poem-new-create {
  font-family: El Messiri;
  font-size: 20px;
  color: var(--color);
  letter-spacing: 2.41px;
  cursor: pointer;
  transition: ease all 0.4s;
  position: absolute;
  left: 1720px;
  bottom: 225px;
}

.create_disabled {
  cursor: default !important;
  color: var(--color_secondary) !important;
}


#preview svg {
  position: absolute;
  right: -8px;
  width: 15px;
  top: -8px;
  cursor: pointer;
}

#preview {
  position: absolute;
  left: 1370px;
  bottom: 230px;
}

#preview img {
  max-height: 100px;
  max-width: 100px;
}

.image-upload {
  position: absolute;
  left: 1520px;
  bottom: 230px;
}

.image-upload > input {
  display: none;
}

.admin__poem-form-img {
  width: 48px;
  height: 48px;
}

.admin__poem-form-img .cls-2, #preview svg polygon {
  fill: #823033;
}


.admin__poem-form-buttons-sub {
  opacity: 0 !important;
}

.admin__poem-form-buttons .visible {
  opacity: 1 !important;
}

.admin__poem-form-buttons button {
  background-color: transparent !important;
}

.admin__poem-form-buttons {
  position: absolute;
  left: 1200px;
  top: 95px;
}

.admin__poem-form-buttons .d-flex button {
  margin-right: 5px;
}

.admin__poem-form-buttons .d-flex {
  margin-bottom: 5px;
}

.admin__poem-new {
  position: absolute;
  width: 1920px;
  height: 1080px;
}

.admin__poem-new-title {
  left: 542px;
  top: 88px;
  position: absolute;


  line-height: 36px;
  text-align: center;
  font-family: El Messiri;
  font-size: 28px;
  color: var(--color);
}

.admin__poem-new-arrow {
  overflow: visible;
  position: absolute;
  width: 16.453px;
  height: 13.358px;
  /*transform: matrix(1,0,0,1,479.0942,130.0503) rotate(90deg);*/
  transform-origin: center;
  left: 480px;
  top: 100px;
  rotate: 90deg;
  cursor: pointer;
}

.admin__poem-new-arrow path {

}

.admin__poem-form-name {
  width: 590px;
  position: absolute;
  left: 542px;
  top: 180px;
}

.admin__poem-form-text {
  width: 1020px;
  position: absolute;
  left: 542px;
  top: 300px;
  height: 45vh !important;
}

.admin__poem-form-location {
  width: 370px;
  position: absolute;
  left: 950px;
  bottom: 230px;
}

.admin__poem-form-date {
  width: 370px;
  position: absolute;
  left: 540px;
  bottom: 220px;
}

#Path_3 {
  fill: transparent;
  stroke: rgba(130, 48, 51, 1);
  stroke-width: 2px;
  stroke-linejoin: miter;
  stroke-linecap: butt;
  stroke-miterlimit: 4;
  shape-rendering: auto;
}

@media (min-width: 1024px) and (max-width: 1440px) {
  .admin__poem-new-arrow {
    left: 380px !important;
  }

  .admin__poem-new-title, .admin__poem-form-name, .admin__poem-form-text, .admin__poem-form-date {
    left: 442px !important;
  }

  .admin__poem-form-text {
    height: 40vh !important;
    top: 250px !important;
    width: 780px !important;
  }

  .admin__poem-form-buttons {
    left: 1050px !important;
  }

  .admin__poem-form-date {
    top: 600px !important;
    bottom: initial !important;
  }

  .admin__poem-form-location {
    left: 850px !important;
    bottom: initial !important;
    top: 605px !important;
  }

  .image-upload {
    left: 442px !important;
    bottom: initial !important;
    top: 685px !important;
  }

  #preview {
    left: 502px !important;
    bottom: initial !important;
    top: 675px !important;
  }

  #preview img {
    max-width: 70px !important;
    max-height: 70px !important;
  }

  .admin__poem-new-create {
    left: 1135px !important;
    bottom: initial !important;
    top: 695px !important;
  }

  .admin__poem-new {
    width: 100vw;
    height: 100vh;
  }
}
</style>